<template>
  <div id="comment-section" class="bg-white rounded-lg border shadow-sm mt-6">
    <div class="pa-4">
      
      <!-- Header Compacto -->
      <div class="d-flex align-center justify-space-between mb-2">
        <h3 class="text-subtitle-2 font-weight-bold text-grey-darken-3 d-flex align-center">
          <v-icon style="font-size: 14px; color: #1A237E;" class="mr-2">fa:fa-solid fa-reply</v-icon>
          Escribir Respuesta
        </h3>
      </div>

      <div class="position-relative">
        
        <!-- Overlay de Carga -->
        <v-overlay v-model="loadingAddAnswer" contained class="align-center justify-center rounded-lg"
          persistent no-click-animation scrim="white" style="opacity: 0.8;">
          <div class="d-flex flex-column align-center">
            <v-progress-circular indeterminate color="primary" size="32" width="3" class="mb-2"></v-progress-circular>
            <span class="text-caption font-weight-bold text-primary">Enviando respuesta...</span>
          </div>
        </v-overlay>

        <v-form v-model="formavalidate" :disabled="loadingAddAnswer">
          
          <!-- Editor de Texto (Sin bordes inferiores para fusionar con toolbar) -->
          <div class="editor-container rounded-t-lg overflow-hidden border-b-0" style="border: 1px solid #e0e0e0; position: relative;">
            <!-- Textarea invisible para validación de Vuetify, pero renderizado en DOM -->
            <v-textarea 
              style="position: absolute; opacity: 0; width: 1px; height: 1px; padding: 0; margin: 0; pointer-events: none; overflow: hidden; z-index: -1;" 
              :rules="[rules.required, rules.textareaSimple]" 
              v-model="answer.message"
              hide-details
            ></v-textarea>
            
            <EditorTexto v-model="answer.message" :height="180" placeholder="Escribe aquí tu respuesta..." />
          </div>

          <!-- Zona de Archivos Adjuntos (Drag & Drop) -->
          <div class="mt-4">
            <FileUploadDragDrop 
              v-model="answer.file"
              :multiple="true"
              :max-size-m-b="10"
            />
          </div>

          <!-- Toolbar de Acciones (Integrada abajo) -->
          <div class="bg-grey-lighten-5 rounded-lg border px-3 py-3 d-flex flex-column mt-4" style="border-color: #e0e0e0 !important;">
            
            <!-- Área de Chips CC seleccionados -->
            <div v-if="answer.cc && answer.cc.length > 0" class="mb-3 d-flex flex-wrap gap-2">
              <!-- CCs -->
              <v-chip v-for="(email, i) in answer.cc" :key="i" size="small" color="grey-darken-3" variant="outlined" label>
                <v-icon style="font-size: 10px; color: inherit;" class="mr-1">fa:fa-solid fa-at</v-icon>
                {{ email }}
              </v-chip>
            </div>

            <!-- Barra de Herramientas -->
            <div class="d-flex align-center justify-space-between flex-wrap gap-2">
              
              <div class="d-flex align-center gap-2">
                <!-- Toggle Notificar -->
                <v-btn size="small" variant="outlined" 
                  @click="answer.notificar = answer.notificar === 'si' ? 'no' : 'si'" 
                  :color="answer.notificar === 'si' ? 'success' : 'grey'"
                  class="text-caption font-weight-bold">
                  <template v-slot:prepend>
                    <v-icon :style="answer.notificar === 'si' ? 'font-size: 14px;' : 'font-size: 14px;'">
                      {{ answer.notificar === 'si' ? 'fa:fa-solid fa-envelope' : 'fa:fa-solid fa-envelope-open' }}
                    </v-icon>
                  </template>
                  {{ answer.notificar === 'si' ? 'Notificar' : 'Sin notificar' }}
                </v-btn>

                <!-- Toggle CC (Menu) -->
                <v-menu v-model="showCCMenu" :close-on-content-click="false" location="top start" offset="10">
                  <template v-slot:activator="{ props }">
                    <v-btn size="small" variant="outlined" v-bind="props" 
                      :disabled="answer.notificar === 'no'" 
                      :color="answer.cc && answer.cc.length > 0 ? 'primary' : 'grey'"
                      class="text-caption font-weight-bold">
                      <template v-slot:prepend>
                        <v-icon style="font-size: 14px;">fa:fa-solid fa-users</v-icon>
                      </template>
                      CC ({{ answer.cc ? answer.cc.length : 0 }})
                    </v-btn>
                  </template>
                  <v-card width="320" class="pa-3 rounded-lg shadow-sm">
                    <div class="text-caption font-weight-bold mb-2 ml-1 text-grey-darken-2">
                      <v-icon style="font-size: 12px; color: #616161;" class="mr-1">fa:fa-solid fa-at</v-icon>
                      Añadir Copias (CC)
                    </div>
                    <v-autocomplete variant="outlined" density="compact" hide-details placeholder="Buscar correo..."
                      v-model="answer.cc" multiple chips closable-chips bg-color="white" color="primary"
                      :items="listaUsuarios" item-value="email" item-title="email" auto-select-first menu-icon="">
                    </v-autocomplete>
                  </v-card>
                </v-menu>
              </div>

              <!-- Botón Enviar -->
              <v-btn :loading="loadingAnswers" :disabled="!canSend" @click="setAnswer(idticket)"
                size="default" rounded="lg" elevation="2" color="primary" class="px-8 font-weight-bold text-capitalize"
                style="background: linear-gradient(135deg, #002B49 0%, #005691 100%);">
                <span>Enviar Respuesta</span>
                <v-icon style="font-size: 14px; color: white;" class="ml-2">fa:fa-solid fa-paper-plane</v-icon>
              </v-btn>

            </div>
          </div>

        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import Filters from "@/modules/Shared/Filters";
import EditorTexto from "@/components/EditorTexto.vue";
import FileUploadDragDrop from "@/components/FileUploadDragDrop.vue";

import { mapState, mapActions, mapMutations } from "vuex";

export default {
  components: {
    EditorTexto,
    FileUploadDragDrop,
  },
  props: {
    idticket:
    {
      type: Number
    }
  },
  mixins: [Filters],
  data() {
    return {
      formavalidate: true,
      showCCMenu: false, // Control del menú CC
    };
  },
  computed: {
    ...mapState('answers', ['answer', 'loadingAnswers', 'loadingAddAnswer', 'copiaCorreo']),
    ...mapState('usuarios', ["listaUsuarios"]), 

    // Validación manual robusta para activar el botón
    canSend() {
      // Verifica si hay mensaje (y no es solo espacios en blanco)
      const hasMessage = this.answer.message && this.answer.message.replace(/<[^>]*>?/gm, '').trim().length > 0;
      return hasMessage;
    }
  },
  watch: {
    loadingAddAnswer(val) {
      if (!val) {
        // La carga terminó (asumimos éxito si no hay manejo de error global que lo impida aquí)
        // Limpiamos el formulario para dar feedback visual y permitir nueva respuesta
        this.answer.message = '';
        this.answer.file = [];
        this.answer.cc = [];
        this.answer.notificar = 'si'; // Reset a notificar por defecto
        this.showCCMenu = false; // Cerrar menú CC
        this.formavalidate = true; // Reset validation state
      }
    }
  },
  methods: {

    ...mapActions('answers', ['setAnswer']),
    ...mapActions('usuarios', ['getAllUser']),
    
  },

  mounted() {
    this.getAllUser()
   },
};
</script>

<style scoped>
.shadow-sm {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06) !important;
}

.gap-2 {
  gap: 8px;
}

.position-relative {
  position: relative;
}
</style>